<template>
    <div>
        <div class="flex jc-sb">
            <label class="flex-20 mr-2">Title/Description</label>
            <label class="flex-20 ml-2 mr-2">Name</label>
            <label class="flex-20 ml-2 mr-2">Email</label>
            <label class="flex-20 ml-2 mr-2">Phone</label>
            <div class="flex-20 ml-2">&nbsp;</div>
        </div>

        <div v-for="(contact, index) in contacts" :key="`additional-contact-${index}`" class="flex jb-sb mt-2">
            <div class="flex-20 mr-1">
                <input disabled type="text" :value="contact.title" />
            </div>

            <div class="flex-20 ml-1 mr-2">
                <input disabled type="text" :value="contact.name" />
            </div>

            <div class="flex-20 ml-1 mr-1">
                <input disabled type="text" :value="contact.email" />
            </div>

            <div class="flex-20 ml-1 mr-1">
                <input disabled type="text" :value="contact.phone" />
            </div>

            <div class="flex-20 ml-1">
                <button type="button" class="danger" @click="onDeleteContact(index)">
                    <i class="material-icons">delete</i>
                </button>
            </div>
        </div>

        <form class="flex fl-sb mt-2" @submit.prevent="onAddNewOption">
            <div class="flex-20 mr-1 pos-r">
                <input class="title-input" type="text" required v-model="title" @focus="show_title_options = true" @blur="show_title_options = false" />

                <div v-show="show_title_options" class="title-options">
                    <div class="title-options-title">
                        <strong>Title Options</strong>
                    </div>

                    <div v-for="option in title_options" :key="`title-option-${option}`" class="title-options-item" @mousedown="title = option">
                        {{ option }}
                    </div>
                </div>
            </div>

            <div class="flex-20 ml-1 mr-1">
                <input type="text" required v-model="name" />
            </div>

            <div class="flex-20 ml-1 mr-1">
                <input type="text" required v-model="email" />
            </div>

            <div class="flex-20 ml-1 mr-1">
                <input type="text" required v-model="phone" />
            </div>

            <div class="flex-20 ml-1">
                <button type="submit">
                    <i class="material-icons">add</i>
                </button>
            </div>
        </form>
    </div>
</template>

<script>
export default {
    props: {
        contacts: {
            required: true,
            type: Array
        }
    },

    data () {
        return {
            email: "",
            name: "",
            phone: "",
            show_title_options: false,
            title: "",
            title_options: [
                "District Manager",
                "Operations Manager",
                "Owner"
            ]
        }
    },

    methods: {
        onAddNewOption () {
            try {
                const email = this.email.trim()
                const name = this.name.trim()
                const phone = this.phone.trim().replace(/[^\d]/g, "")
                const title = this.title.trim()

                if (title.length === 0) {
                    throw new Error("Title cannot be empty")
                }

                if (name.length === 0) {
                    throw new Error("Name cannot be empty")
                }

                if (email.length === 0) {
                    throw new Error("Email cannot be empty")
                }

                const contacts = this.contacts.concat([{ email, name, phone, title }])

                this.email = ""
                this.name = ""
                this.phone = ""
                this.title = ""

                this.$emit("change", contacts)
            } catch (ex) {
                this.$eventManager.emit("add-toast", { message: ex.message, type: "error" })
            }
        },

        onDeleteContact (index) {
            this.contacts.splice(index, 1)

            this.$emit("change", this.contacts)
        }
    }
}
</script>

<style scoped>
.title-options {
    background: #ffffff;
    border: 1px solid #b7b7b7;
    bottom: 100%;
    position: absolute;
    width: 100%;
}

.title-options-title {
    background: #e0e0e0;
    border-bottom: 1px solid #b7b7b7;
    line-height: 1;
    padding: 10px;
}

.title-options-item {
    background: transparent;
    cursor: pointer;
    line-height: 1;
    padding: 10px;
    transition: all 0.15s ease;
}

.title-options-item:hover {
    background: #f2f2f2;
}
</style>



// WEBPACK FOOTER //
// src/components/add-facility-page/AdditionalContacts.vue